import React from "react";
import styled from "styled-components";
import { Dialog, Item } from "@zebra-fed/zds-react-desktop";
import {useTranslation} from "react-i18next";

const StyledContent = styled.div`
  width: 472px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 28px;
  padding-left: 24px;
  padding-right: 24px;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  height: 50px;
  font-size: 18px;
  background-color: #007aba;
  background-color: ${props => props.color};
  width: 472px;
  color: white;
  align-items: center;
  padding: 0 24px;
  justify-content: center;
`;

const ModalContent = props => {
  let str = "";
  if (props.content) {
    str = props.content.toString();
  } else {
    str = "An error occurred";
  }
  return <StyledContent color={props.color}>{str}</StyledContent>;
};

const ModalHeader = props => {
  let str = "";
  if (props.header) {
    str = props.header;
  } else {
    str = "An error occurred";
  }
  return <StyledHeader color={props.color}>{str}</StyledHeader>;
};
export default function EmptyModal(props) {
  const dialogRef = props.modalRef;
  const {t} = useTranslation()

  return (
    <>
      <Dialog
        ref={dialogRef}
        key="modal"
        width="520px"
        headerStyle={{ display: "none" }}
        bodyStyle={{ padding: "0px", width: "520px" }}
        footerStyle={{ padding: "52px 24px 24px 24px" }}
        items={[
          <Item
            type="button"
            style={{
              width: "102px",
              backgroundColor: props.color ? props.color : "#007ABA",
            }}
            onClick={() => {
              dialogRef.current.toggleDialog();
            }}
          >
              {t('close')}
          </Item>,
        ]}
      >
        <ModalHeader header={props.header} color={props.color} />
        <ModalContent content={props.content} />
      </Dialog>
    </>
  );
}